import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth";
import { CurrencyProvider } from "./lib/currency";
import PublicStore from "./pages/PublicStore";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Settings from "./pages/Settings";
import SalesHistory from "./pages/SalesHistory";
import Fiados from "./pages/Fiados";
import Financials from "./pages/Financials";
import Encomendas from "./pages/Encomendas";
import EncomendaDetail from "./pages/EncomendaDetail";
import ShoppingList from "./pages/ShoppingList";
import Categories from "./pages/Categories";
import Expenses from "./pages/Expenses";
import Losses from "./pages/Losses";
import MoneySplit from "./pages/MoneySplit";

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicStore />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/dashboard/vendas" element={<SalesHistory />} />
              <Route path="/dashboard/fiados" element={<Fiados />} />
              <Route path="/dashboard/financeiro" element={<Financials />} />
              <Route path="/dashboard/encomendas" element={<Encomendas />} />
              <Route path="/dashboard/encomendas/:id" element={<EncomendaDetail />} />
              <Route path="/dashboard/lista-compras" element={<ShoppingList />} />
              <Route path="/dashboard/categorias" element={<Categories />} />
              <Route path="/dashboard/despesas" element={<Expenses />} />
              <Route path="/dashboard/quebras" element={<Losses />} />
              <Route path="/dashboard/divisao" element={<MoneySplit />} />
              <Route path="/dashboard/settings" element={<Settings />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </CurrencyProvider>
      </AuthProvider>
    </div>
  );
}
